module.exports = __webpack_public_path__ + "static/media/interview13.cab381b2.jpg";